// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__5QEED","col":"styles_col__3nFqS"};